export default __webpack_public_path__ + "static/media/HERO_MD.cc36dfb8.png";